import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import AppRoutes from "./routes/AppRoutes";
import "./App.css";
import { UserProvider } from "././components/Navbar/UserContext";

function App() {
  return (
    <ChakraProvider>
      <BrowserRouter>
        <UserProvider>
          <AppRoutes />
        </UserProvider>
      </BrowserRouter>
    </ChakraProvider>
  );
}

export default App;
